import { mapGetters } from 'vuex';
import mvtMortgageMrc from '@/common/components/mvtmortgage/mrcmortgagerates/mrc-mortgagerates.vue';

const isSSR = typeof window === 'undefined';

const titleDescMapper = { apply: 'apply', getpreapproved: 'getpreapproved', findlender: 'findlender', prequalify: 'getprequalified', fha: 'fhalow' };
const fallbackCampaignMapper = { fha_lp: 'Check_FHA_Eligibility_LP', getpreapprovedATF_LP: 'getpreapprovedATF_LP', getpreapproved_LP: 'getpreapproved_LP', findalender_LP: 'findalender_LP' };

export default {
    name: 'pageMortgageMRC',
    inject: ['$eventBus'],
    components: {
        mvtMortgageMrc,
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb']),
        options() {
            if (isSSR) {
                return null;
            }
            let opt;
            const queryObj = new URLSearchParams(window.location.search);
            const title = queryObj.get('title').toLowerCase();
            if (queryObj) {
                opt = {
                    showNormalMrc: true,
                    utm_campaign: fallbackCampaignMapper[queryObj.get('fallback').toLowerCase()] || queryObj.get('fallback'),
                    desc: titleDescMapper[title],
                };
            }
            return opt;
        },
    },
    methods: {
        openHome() {
            window.open(this.glb.appUrl);
        },
        enableKeyboardSupport(e) {
            if (e.keyCode === 13 || e.keyCode === 32) {
                e.preventDefault();
                e.target.click();
            }
        },
    },
    mounted() {
        this.$eventBus.$emit('eventbus-pageLoaded');
    },
};
